export const VERSION = process.env.NEXT_PUBLIC_VERSION;
export const DOMAIN_PUBLIC = process.env.NEXT_PUBLIC_DOMAIN_PUBLIC;
export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const PATHNAME = process.env.NEXT_PUBLIC_PATHNAME;
export const MONGO_API = process.env.NEXT_PUBLIC_MONGO_API;
export const MERCHANT = process.env.NEXT_PUBLIC_MERCHANT;
export const CUSTOM_INVENTORY = process.env.NEXT_PUBLIC_CUSTOM_INVENTORY;
export const LOCALE = process.env.NEXT_PUBLIC_LOCALE;
export const CURRENCY = process.env.NEXT_PUBLIC_CURRENCY;
export const CURRENCY_SYMBOL = process.env.NEXT_PUBLIC_CURRENCY_SYMBOL;
export const ESPOTS = process.env.NEXT_PUBLIC_ESPOTS;
export const CDN = process.env.NEXT_PUBLIC_CDN_PATH;
export const QUERY_MOBILE = '(max-width: 760px)';
export const CONFIG_KEY = process.env.NEXT_PUBLIC_CONFIG_KEY;
export const PREPAGO = 'PREPAGO';
export const OTRO = 'OTRO';
export const POSPAGO = 'POSPAGO';
export const PLAN = 'PLAN';
export const PLANFIJO = 'PLANFIJO';
export const TYPE_PREPAGO = '1';
export const TYPE_PLAN = '2';
export const TYPE_EQUIPO = '4';
export const TYPE_ACCESORIO = '5';
export const TYPE_POSPAGO = '6';
export const TYPE_PLAN_CLARO_HOGAR = '9';
export const OFERTA_RENOVACION = 'RENOVACION';
export const APPROVED = 'APPROVED';
export const ATTR_TIPO_POSPAGO = 'attr-tipo-postpago';
export const FILT_TIPO_DE_PLAN = 'filt-tipo-de-plan';
export const ATTR_LIMITE_INVENTARIO = 'attr-limite-inventario';

// espot config
export const PLANES_CLARO_HOGAR = 'planes-claro-hogar';

// chatbot
export const CHATBOT_TOKEN_ANON = process.env.NEXT_PUBLIC_CHATBOT_TOKEN_ANON;
export const CHATBOT_TOKEN_AUTH = process.env.NEXT_PUBLIC_CHATBOT_TOKEN_AUTH;
